import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

type Props = {};

const ATMFullPageLoader = (props: Props) => {
  return (
    <Backdrop open>
      <CircularProgress size={20} />
    </Backdrop>
  );
};

export default ATMFullPageLoader;
